import React from "react";

import { makeStyles } from "@material-ui/core";
import { clsx } from "clsx";

const useStyle = makeStyles((theme) => {
  return {
    root: (props) => ({
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      margin: theme.spacing(1.5),
      ...props?.styles?.root,

      [theme.breakpoints.down("lg")]: {
        flexWrap: "wrap",
      },
    }),
    labelClass: (props) => ({
      fontSize: 20,
      fontWeight: 700,
      margin: 0,
      ...props?.styles?.labelClass,
    }),
  };
});

export default function DashboardCardHeader(props) {
  const classes = useStyle(props);

  return (
    <div className={clsx(classes.root, props.className)}>
      <div className={classes.labelClass}>
        {props.label}
        <span style={{ fontWeight: 300 }}>{props.subLabel}</span>
      </div>
      {props.children}
    </div>
  );
}
